export const EDIT_TRANSLATION_MODE_KEY = 'editTranslationMode';